<template>
  <div class="pa-4">
    <portal-page-header
      :title="displayTitle"
      subtitle="Contenido del módulo disponible próximamente."
    />
  </div>
</template>

<script>
import PortalPageHeader from '../../../components/layout/PortalPageHeader.vue'

export default {
  name: 'PortalModulePlaceholder',
  components: { PortalPageHeader },
  props: {
    modulePath: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayTitle() {
      const s = String(this.modulePath || '').trim()
      if (!s) return 'Módulo'
      return s.replace(/\//g, ' · ')
    },
  },
}
</script>
